// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-routes_emptySkeleton{width:100%;height:100vh}", "",{"version":3,"sources":["webpack://./src/components/app-routes/styles.module.scss"],"names":[],"mappings":"AAAA,0BACE,UAAA,CACA,YAAA","sourcesContent":[".emptySkeleton {\n  width: 100%;\n  height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"emptySkeleton": "app-routes_emptySkeleton"
};
export default ___CSS_LOADER_EXPORT___;
